import React, { useContext, useState, useEffect, useRef } from 'react';
import { Table, Dropdown, Pagination,Popover, Whisper  } from 'rsuite';
import './client-report-table.scss';
import 'rsuite/dist/rsuite.min.css';
import { default as t } from '../../../utils/i18n';
import { Button, ModalWindow, AppTooltip, ActionLink } from '../../atoms';
import { DashService, AnalysisService, ReportsService } from '../../../services';
import { UserContext, ToasterContext } from '../../../context';
import { useHistory } from 'react-router-dom';
import { useDebounceEffect } from '../../../hooks';
import { ReactComponent as DeleteIcon } from '../../../assets/svg/trash-outline.svg';

import { ReactComponent as KebabIcon } from '../../../assets/svg/kebab.svg';
import fileDownload from 'js-file-download';
import axios from '../../../utils/axios';
import axiosStat from 'axios';

function ClientReportTable(props) {
  const automatedReportType = 'submitted';
  const draftReportType = 'draft';
  const { user , setUser} = useContext(UserContext);
  const history = useHistory();
  const { message, setMessage } = useContext(ToasterContext);
  const userAccessToken = user?.tokens?.accessToken?.jwtToken;
  const username = user?.username;
  const [sortColumn, setSortColumn] = React.useState('');
  const [sortType, setSortType] = React.useState('asc');
  const [isNickName, setIsNickName] = React.useState(true);
  const [toaster, setToaster] = useState(false);
  const [showDeleteReportModal, setShowDeleteReportModal] = useState(false);
  const [limit, setLimit] = React.useState(10);
  const [page, setPage] = React.useState(1);
  const [rowSelectedData, setRowSelectedData] = React.useState(true);
  const [tableList, SetTableList] = React.useState(props?.reportsList);
  const [deleteData, setDeleteData] = useState({});
  const [reportData, setReportData] = useState([]);
  const whisperRef = useRef(null);
  const [dimensions, setDimensions] = React.useState({
    height: window.innerHeight,
    width: window.innerWidth,
  });
  const [disableLoader, toggleLoader] = useState(true);
  const loaderTimeout = 180000;

  useEffect(() => {
    if (message?.message && (user?.isSaveDraft || user?.isSubmitted)) {
      setToaster(true);
      setUser(() => ({
        ...user,
        isSaveDraft: false,
        isSubmitted: false
      }));
      clearToaster();
    }
  }, []);

  React.useEffect(() => {
    function handleResize() {
      setDimensions({
        height: window.innerHeight,
        width: window.innerWidth,
      });
    }
    window.addEventListener('resize', handleResize);
    return _ => {
      window.removeEventListener('resize', handleResize);
    };
  });

  useEffect(() => {
    setTimeout(() => {
      toggleLoader(false);
    }, loaderTimeout);
  });

  const clearToaster = () => {
    setTimeout(() => {
      console.log('clear called');
      setToaster(false);
    }, 7000);
  };

  useEffect(() => {
    if (props?.selectedAdAccount?.value) {
      setPage(1);
      getReportsForAdaccount(1);
    }
  }, [props?.selectedAdAccount]);


  const getReportsForAdaccount = async (pageNo = false, sortCol = false, sortingType = false, currentlimit = 10) => {
    let pageLimit = currentlimit ? currentlimit : limit;
    let pagination = pageNo ? pageNo : page;
    const sortColumnName = sortCol ? sortCol : sortColumn;
    const sortingTypeName = sortingType ? sortingType : sortType;
    try {

      const reportListData = await DashService.getReportsForAdaccount(
        userAccessToken,
        username,
        props?.selectedAdverse?.value,
        props?.selectedAdAccount?.value,
        props?.reportType,
        props?.searchKeyword.trim(),
        props?.dropdownFilterby,
        pageLimit,
        pageNo,
        sortColumnName,
        sortingTypeName
      );
      const reportsList = reportListData?.data?.data;
      setReportData(reportsList);
      SetTableList([...reportsList?.reportsList]);
      props.updateCount(reportsList?.pagination?.totalRecords, props?.reportType);
      if (props?.reportType === automatedReportType && pagination === 1) {
        const draftReportData = await DashService.getReportsForAdaccount(
          userAccessToken,
          username,
          props?.selectedAdverse?.value,
          props?.selectedAdAccount?.value,
          draftReportType,
          props?.searchKeyword.trim(),
          props?.dropdownFilterby,
          limit,
          pageNo,
          sortColumnName,
        sortingTypeName
        );
        props.updateCount(draftReportData?.data?.data?.pagination?.totalRecords, draftReportType);
      }
    } catch (error) {}
  };

  const updateDateFormat = val => {
    const d = new Date(val);
    d.setUTCHours(0, 0, 0, 0);
    const yyyy = d.getFullYear();
    let mm = d.getMonth() + 1; // Months start at 0!
    let dd = d.getDate();

    if (dd < 10) dd = '0' + dd;
    if (mm < 10) mm = '0' + mm;
    return dd + '-' + mm + '-' + yyyy;
  };

  const getDateRange = (startTime, stopTime) => {
    if (stopTime) {
      return updateDateFormat(startTime) + ' to ' + updateDateFormat(stopTime);
    } else {
      return updateDateFormat(startTime) + ' ' + 'onwards';
    }
  };

  const getData = () => {
    const tableData = [];
    tableList?.map((list, index) => {
      const childCount = list?.reportCycles?.length;
      let processedStatus;
      list.reportCycles.find(cyc => {
        if(cyc.reportId === list.reportId && cyc?.processedStatus?.reason) {
          processedStatus = cyc?.processedStatus;
        }
      })
      let data = {
        key: index + Math.random().toString(),
        reportId: list.reportId,
        reportName: list.reportName,
        advertiser: list.advertiser,
        type: list.type,
        updatedAt: updateDateFormat(list.updatedAt),
        status: list.status,
        reportingDate: `${updateDateFormat(list.startDate)} -  ${updateDateFormat(list.endDate)}`,
        childCount:childCount,
        cycleId:  (list?.type === 'EOCR' || 'PCA ') ? list?.reportCycles[0]?._id : '',
        processedStatus: processedStatus
      };
      if (childCount > 0 && list.type != 'EOCR' && list.type != 'PCA') {
        data.children = generateChildren(list);
      }
      tableData.push(data);
    });
    return tableData;
  };

  const generateChildren = list => {
    let children = [];
    list.reportCycles.map((el, index) => {
      children.push({
        _id: el._id,
        key: index + Math.random().toString(),
        reportId: el.reportId,
        reportName: list.reportName,
        advertiser: list.advertiser,
        type: list.type,
        updatedAt: updateDateFormat(el.deliveryDate),
        status: el.status,
        reportingDate: `${updateDateFormat(el.startDate)} -  ${updateDateFormat(el.endDate)}`,
        isChild: true,
        processedStatus: el.processedStatus
      });
    });
    return children;
  };

  const handleSortColumn = (sortColumn, sortType) => {
    setPage(1);
    setSortColumn(sortColumn);
    setSortType(sortType);
    getReportsForAdaccount(1, sortColumn, sortType);
  };

  const getActiveStepForReport = (reportDetails) => {
    const metricsWithPrimaryKPI = reportDetails?.metrics.filter(metric => metric.isPrimaryKpi === true);
    if(reportDetails?.metrics?.length > 0 && reportDetails?.currency !== null && metricsWithPrimaryKPI?.length > 0){
      return 3;
    } 
    if( reportDetails?.reportBreakdown.length > 0 && reportDetails?.currency !== null && metricsWithPrimaryKPI?.length > 0){
      return 4;
    }
    return 2;
  }

  const handleRowClick = async (rowData) => {
    if(rowData?.status === "DRAFT" && rowSelectedData){
      try {
        const reportListData = await DashService.getReportData(
          userAccessToken,
          username,
          rowData?.reportId
        );
        const reportDetails = reportListData?.data?.data;
        const activeStep = getActiveStepForReport(reportDetails);
        setUser(prevUser => ({
          ...user,
          activeStep,
          'draftReportId' : rowData?.reportId,
          'reportName' :  rowData?.reportName
        }));
      } catch (error) {
        throw error.response;
      }

      history.push("/define-report");
    }else if (rowData?.status === 'READY') {
      if (rowData?.type === "LIVE" && !rowData?.children) {
        history.push(`/report-output?reportId=${rowData.reportId}&cycleId=${rowData._id}`);
      } else if (rowData?.type === "EOCR" || rowData?.type === "PCA") {
        history.push(`/report-output?reportId=${rowData.reportId}&cycleId=${rowData.cycleId}`);
      }
    }
  };

  const toggleName = e => {
    e.stopPropagation();
    setIsNickName(!isNickName);
  };

  const downloadExcel = async (e, reportId, cycleId) => {
    try {
      const response = await ReportsService.downloadXcel(
        userAccessToken,
        username,
        reportId,
        cycleId
      );
      const url = new URL(response?.data?.data);
      const fileName = url.pathname.replace(/^.*[\\\/]/, '');
      const api = axiosStat.create({
        baseURL: axios.defaults.baseURL.slice(0, -4),
      });
      api
        .get(url, {
          responseType: 'blob',
        })
        .then(res => {
          fileDownload(res.data, fileName);
        });
    } catch (error) {
      const dataCode = error?.data?.data?.code;
      if (dataCode) {
        console.log(dataCode);
      }
    }
  };

  const deleteReport = (event, data) => {
    event?.stopPropagation();
    const deleteObj = data;
    deleteObj['subHeading'] = deleteObj._id || deleteObj.status === 'DRAFT' ? t('client.report.table.delete.warning') : t('client.report.table.delete.warning.parent');
    setDeleteData(deleteObj);
    setShowDeleteReportModal(true);
  };

  const handleOnCloseDeleteModal = () => {
    setShowDeleteReportModal(false);
  };

  const handleOnCancel = e => {
    e.preventDefault();
    setShowDeleteReportModal(false);
  };

  const handleOnConfirm = async () => {
    const payload = {};
    if (deleteData._id) {
      payload['reportId'] = deleteData.reportId;
      payload['cycleId'] = deleteData._id;
    } else {
      payload['reportId'] = deleteData.reportId;
    }
 
    handleDeleteReport(payload);
  };

  async function handleDeleteReport(payload) {
    try {
      const deleteRes = await ReportsService.deleteReport(
        userAccessToken,
        username,
        payload
      );
      const delResponse = deleteRes.data?.data;
      if(delResponse.message === "Successfully Updated"){
        setShowDeleteReportModal(false);
        getReportsForAdaccount(1);
      }
    } catch (error) {
      setShowDeleteReportModal(false);
    }
  }

  const handleChangeLimit = dataKey => {
    setLimit(dataKey);
    setPage(1);
    getReportsForAdaccount(1, false, false, dataKey)
  };

  useDebounceEffect(
    () => {
      if (props?.selectedAdAccount) {
        getReportsForAdaccount()
        setPage(1);
      }
    },
    500,
    [props?.dropdownFilterby, props?.searchKeyword]
  );

  const onExpandChange = async (expanded, rowData) => {
    if (expanded && rowData.status === 'NOTIFY') {
      try {
        const response = await AnalysisService.notifyAnalysis(
          userAccessToken,
          username,
          rowData?.id
        );
        console.log('response from NOTIFY', response);
        // TODO: test after API changes.
        let items = [...tableList];
        var foundIndex = items.findIndex(x => x.id == rowData.id);

        let item = { ...items[foundIndex] };
        item.analysis.map(x => {
          x.toBeNotified = false;
        });

        items[foundIndex] = item;
        // 5. Set the state to our new copy
        SetTableList(items);
      } catch (error) {}
    }
  };

  const TableCell = ({ rowData, dataKey, ...props }) => {
    return (
      <Table.Cell
        {...props}
        title={rowData[dataKey]}
        className={`${rowData?.isChild ? 'child-background' : ''} 
        ${
          (rowData.status === 'READY' || rowData.is_readyForAnalysis) && rowData?.children
            ? 'pointer-auto'
            : rowData.status === 'READY' || rowData.is_readyForAnalysis
            ? ''
            : ''
        }`}
      >
        {rowData[dataKey]}
      </Table.Cell>
    );
  };

  const NameCell = ({ rowData, dataKey, isNickName, onChange, ...props }) => {
    return (
      <div>
        <AppTooltip id="tool-tip" place="left" className="c-table-info-icon--tooltip" />
        <Table.Cell
          {...props}
          className={`${rowData?.isChild ? 'campaign-name child-padding' : 'campaign-name'} ${
            (rowData.status === 'READY' || rowData.is_readyForAnalysis) && rowData?.children
              ? 'pointer-auto'
              : rowData.status === 'READY' || rowData.is_readyForAnalysis
              ? ''
              : ''
          }`}
          title={rowData[dataKey]}
          rowData={rowData}
        >
          {<span>{isNickName ? rowData[dataKey] : rowData['reportId']}</span>}
        </Table.Cell>
      </div>
    );
  };

  const getWidth = (value = 10) => {
    return window.innerWidth / value;
  };
  const StatusCell = ({ rowData, dataKey, onChange, ...props }) => {
    
    return (
      <Table.Cell {...props} className={`${rowData?.isChild ? 'child-background' : ''}`}>
        <div>
          <AppTooltip id="tool-tip1" place="left" className="c-table-info-icon--tooltip" />
          <div
            className={`options ${
              rowData[dataKey] === 'PROCESSING'
                ? 'in-progress'
                : rowData[dataKey] === 'READY'
                ? 'ready'
                : rowData[dataKey] === 'NEW'|| rowData[dataKey] === 'TO_BE_PROCESSED'
                ? 'new'
                : rowData[dataKey] === 'SUBMITTED'
                ? 'veiw'
                : rowData[dataKey] === 'ANALYZE'
                ? 'analyze'
                : rowData[dataKey] === 'NOTIFY'
                ? 'notify'
                : rowData[dataKey] === 'ERROR'?  'error': 'new'
            }`}
          >
            {rowData[dataKey] === 'PROCESSING' ? (
              <>
                <span>
                  <i className="eva eva-clock-outline"></i>
                  {t('perf.process')}
                </span>
              </>
            ) : (
              ''
            )}
            {rowData[dataKey] === 'READY' ? (
              <>
                <span>
                  <i className="eva eva-bell-outline"></i>
                  {t('perf.ready')}
                </span>
              </>
            ) : (
              ''
            )}
            {rowData[dataKey] === 'NEW' || rowData[dataKey]=== 'TO_BE_PROCESSED' ? (
              <>
                <span>
                <i className="eva eva-alert-circle-outline new"></i>
                  {t('perf.new')}
                </span>
              </>
            ) : (
              ''
            )}

            {rowData[dataKey] === 'ANALYZE' ? (
              <>
                  <span className="analyze">
                    <i className="eva eva-search"></i>
                    {t('perf.analyse')}
                  </span>
               
              </>
            ) : (
              ''
            )}
            {rowData[dataKey] === 'NOTIFY' ? (
              <>
                <span className="notify">
                  <i className="eva eva-bell"></i>
                </span>
              </>
            ) : (
              ''
            )}
            {rowData[dataKey] === 'SUBMITTED' ? (
              <>
                <span>
                  <i className="eva eva-checkmark-circle-2-outline"></i>
                  {t('Submitted')}
                </span>
              </>
            ) : (
              ''
            )}

            {rowData[dataKey] === 'ERROR' ? (
              <>
                <span>
                  {' '}
                  <i className="eva eva-alert-triangle-outline" data-tip={rowData?.processedStatus?.reason }
                data-for="tool-tip1"></i>
                  {t('create.report.show.answer.option.options5.type')}
                </span>
              </>
            ) : (
              ''
            )}
            {rowData[dataKey] !== 'NEW' &&
            rowData[dataKey]!== 'TO_BE_PROCESSED' &&
            rowData[dataKey] !== 'PROCESSING' && 
            rowData[dataKey] !== 'READY' &&
            rowData[dataKey] !== 'ANALYZE' && 
            rowData[dataKey] !== 'NOTIFY' &&
            rowData[dataKey] !== 'SUBMITTED' &&
            rowData[dataKey] !== 'ERROR'
            ? (
              <>
                <span>
                <i className="eva eva-alert-circle-outline new"></i>
                  {rowData[dataKey]}
                </span>
              </>
            ) : (
              ''
            )}
          </div>
        </div>
      </Table.Cell>
    );
  };

  const ActionCell = ({ rowData, dataKey, isNickName, onClick, ...props }) => {
   
    const handleClick = (event, data) => {
      setRowSelectedData(false);
      deleteReport(event, data)
      setRowSelectedData(true);
    };
    return (
      <Table.Cell {...props} 
      title={rowData[dataKey]} 
      rowData={rowData}  
      >
        <div onClick={(event) => {
          handleClick(event, rowData);
        }}>
          <DeleteIcon className="icon-size"/>
        </div>
      </Table.Cell>
    );
  };

  
  const OptionCell = ({ rowData, dataKey, ...props }) => {
    const handleSelect = (eventKey, event) => {
      if(event.target.innerText === 'Delete Report'){
        deleteReport(event, eventKey)
      }else {
        if(eventKey.status === 'READY'){
          downloadExcel(event, eventKey.reportId, eventKey.cycleId)
        }
      }
      whisperRef.current.close();
    };
    
    const handleClick = (event) => {
      if(rowData?.type === "EOCR" || rowData?.type === "PCA" || rowData?.type === "LIVE"){
      event.stopPropagation(); 
      }
    };

    return (
      <Table.Cell title={rowData[dataKey]}  {...props} className={`${rowData?.isChild ? 'child-background' : ''}`} onClick={handleClick}>
        <Whisper ref={whisperRef} placement="auto"  trigger='click' speaker={
        <Popover>
         <Dropdown.Menu onSelect={handleSelect}>
         {rowData.status === 'READY' ? <Dropdown.Item eventKey={rowData}>{t('report.delete.as.excel')}</Dropdown.Item> : ''}
          <Dropdown.Item eventKey={rowData}>{t('report.delete.report')}</Dropdown.Item>
        </Dropdown.Menu>
        </Popover>
        }
        >
        <KebabIcon />
        </Whisper>
      </Table.Cell>
    );
  };

  const loadMore = (currentPage) => {
    if (
      props?.selectedAdAccount?.value &&
      tableList?.length < reportData?.pagination?.totalRecords
    ) {
      setPage(currentPage);
      getReportsForAdaccount(currentPage)
    }
  };


  return (
    <div className='client-report-table'>
      <div className="sticky-toaster">
        {toaster ? (
          <div className="report-toaster report-toaster-pos">
            {!message.isError && (
              <span>
                <i className="eva eva-checkmark-outline"></i>
              </span>
            )}
            {message.isError && (
              <div className="icon-error">
                <i className="eva eva-close-outline"></i>
              </div>
            )}
            {message?.message}
          </div>
        ) : (
          ''
        )}
      </div>

      <AppTooltip id="tool-tip" place="left" className="c-table-info-icon--tooltip" />
      <>
        <div className="report-performance">
          <Table
            isTree={true}
            rowKey="key"
            data={getData()}
            sortColumn={sortColumn}
            sortType={sortType}
            headerHeight={50}
            autoHeight={true}
            onSortColumn={handleSortColumn}
            onRowClick={e => handleRowClick(e)}
            virtualized
            affixHeader={225}
            className={'pointer-cursor'}
            onExpandChange={(event, rowData) => onExpandChange(event, rowData)}
          >
           

            {/* Report Name Column */}
            <Table.Column width={getWidth(4)} align="left" sortable >
                <Table.HeaderCell>
                <i
                  className="eva eva-repeat-outline"
                  data-tip={
                    isNickName ? t('report.tooltip.toggle2') : t('report.table.show.report.name')
                  }
                  data-for="tool-tip"
                  onClick={event => toggleName(event)}
                ></i>
                {isNickName ? t('reportTable.text.reportName') : t('reportTable.text.reportId')}
                <span className="name-padding">
                  <i
                    className="eva eva-info-outline"
                    data-tip={t('client.report.table.tooltip.reportName')}
                    data-for="tool-tip3"
                  ></i>
                  <AppTooltip
                    className="c-table-info-icon--tooltip"
                    id="tool-tip3"
                    place="bottom"
                  />
                </span>
              </Table.HeaderCell>
              <NameCell dataKey="reportName" isNickName={isNickName} />
            </Table.Column>

            {/* Advertiser Column */}

            <Table.Column width={getWidth(9)} sortable resizable>
              <Table.HeaderCell>{t('reportTable.text.advertiser')}
              <span className="advertiser-padding">
                    <i
                      className="eva eva-info-outline"
                      data-tip={t('client.report.table.tooltip.advertiser')}
                      data-for="tool-tip2"
                    ></i>
                    <AppTooltip
                      className="c-table-info-icon--tooltip"
                      id="tool-tip2"
                      place="bottom"
                    />
                  </span>
                  </Table.HeaderCell>
              <TableCell dataKey="advertiser" />
            </Table.Column>

            <Table.Column width={getWidth(9)} sortable resizable>
              <Table.HeaderCell>{t('define.summary.reportType')}
              <span className="type-padding">
                    <i
                      className="eva eva-info-outline"
                      data-tip={t('client.report.table.tooltip.report.type')}
                      data-for="tool-tip2"
                    ></i>
                    <AppTooltip
                      className="c-table-info-icon--tooltip"
                      id="tool-tip2"
                      place="bottom"
                    />
                  </span>
              </Table.HeaderCell>
              <TableCell dataKey="type"></TableCell>
            </Table.Column>

            <Table.Column width={getWidth(7)} sortable resizable>
              <Table.HeaderCell>{t('report.table.reporting.date')}
              <span className="reporting-padding">
                  <i
                    className="eva eva-info-outline"
                    data-tip={t('client.report.table.tooltip.reporting.date')}
                    data-for="tool-tip2"
                  />
                  <AppTooltip
                    className="c-table-info-icon--tooltip"
                    id="tool-tip2"
                    place="bottom"
                  />
                </span>
              </Table.HeaderCell>
              <TableCell dataKey="reportingDate" />
            </Table.Column>

            {/* Date Column */}
            <Table.Column width={getWidth(6)} sortable resizable>
              <Table.HeaderCell>
                {t('report.table.report.date')}
                <span className="date-padding">
                  <i
                    className="eva eva-info-outline"
                    data-tip={t('client.report.table.tooltip.date')}
                    data-for="tool-tip2"
                  />
                  <AppTooltip
                    className="c-table-info-icon--tooltip"
                    id="tool-tip2"
                    place="bottom"
                  />
                </span>
              </Table.HeaderCell>
              <TableCell dataKey="updatedAt" />
            </Table.Column>

            {props?.reportType == automatedReportType ? (
              <>
                <Table.Column width={getWidth(10)} sortable>
                  <Table.HeaderCell>{t('reportTable.text.status')}
                  <span className="status-padding">
                    <i
                      className="eva eva-info-outline"
                      data-tip={t('client.report.table.tooltip.status')}
                      data-for="tool-tip2"
                    ></i>
                    <AppTooltip
                      className="c-table-info-icon--tooltip"
                      id="tool-tip2"
                      place="bottom"
                    />
                  </span>
                  </Table.HeaderCell>
                  <StatusCell dataKey="status" campaigntype={props?.reportType} />
                </Table.Column>
                <Table.Column width={getWidth(15)}>
                  <Table.HeaderCell></Table.HeaderCell>
                  <OptionCell dataKey="reportId" />
                </Table.Column>
              </>
            ) : (
              <Table.Column width={getWidth(5)}>
                <Table.HeaderCell>{t('client.report.actions')}</Table.HeaderCell>
                <ActionCell  dataKey="reportId"/>
              </Table.Column>
            )}
          </Table>
        </div>
      </>
      <div className="pagination-div">
        <span>{t('report.table.rows.page')}</span>
        <Pagination
          prev
          next
          first
          last
          ellipsis
          boundaryLinks
          maxButtons={5}
          layout={['-', 'limit', '|', 'pager']}
          total={reportData?.pagination?.totalRecords}
          limitOptions={[10, 15]}
          limit={limit}
          activePage={page}
          onChangePage={loadMore}
          onChangeLimit={handleChangeLimit}
        />
      </div>
      <div className="report-delete">
        <ModalWindow
          className="fqa-modal--showanswer"
          isOpen={showDeleteReportModal}
          onRequestClose={handleOnCloseDeleteModal}
          heading={t('reportTable.campaign.delete.heading')}
        >
          <p className="fqa-model-showanswer--message message-font">{deleteData?.subHeading}</p>
          <div className="fqa-model-pa--actions">
            <ActionLink
              anchor={true}
              value={t('reportTable.campaign.delete.cancel')}
              handleClick={handleOnCancel}
            />
            <Button
              className="fqa-model-pa--actions-confirm delete-button"
              label={t('reportTable.campaign.delete')}
              handleClick={handleOnConfirm}
            />
          </div>
        </ModalWindow>
      </div>
    </div>
  );
}

export default ClientReportTable;
